import { Block } from '../block.js'
import { ForBlock } from '../logic/for-block.js'
import { TextBlock } from './text-block.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { Expression } from '../../data/text-or-code.js'
import { DraggableBlock } from './draggable-block.js'
import { DropListBlock } from './drop-list-block.js'

@jsonClass('DropListGroupBlock')
export class DropListGroupBlock extends Block {
	constructor(init: Partial<DropListGroupBlock> = {}) {
		super()
		this.init(init)
	}

	static createNewForEditor(): Block {
		const forBlock = new ForBlock()
		forBlock.children = [
			new DraggableBlock({
				dataExpression: new Expression(forBlock.loopVariableDefinition),
			}),
		]
		return new this({
			children: [
				DropListBlock.createNewForEditor(),
				DropListBlock.createNewForEditor(),
			],
		})
	}

	getPreviewDirection(): 'row' | 'column' {
		return this.parent?.getPreviewDirection() ?? 'row'
	}

	getEditorCategory(): string {
		return 'Others'
	}
}
